<template>
  <button
      class="search-form-button"
      type="button"
      @click="$emit('click')"
  >
    <slot>Wyszukaj</slot>
  </button>
</template>

<script>
export default {
  name: 'SearchFormButton',
  emits: ['click']
}
</script>

<style scoped lang="scss">
.search-form-button{
  width: 100%;
  min-height: 46px;
  padding: 0 28px;
  border: none;
  border-radius: 8px;
  background: #10b981;
  color: #ffffff;
  font-size: 1.6rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color .2s ease, box-shadow .2s ease, transform .1s ease;
  box-shadow: 0 6px 16px rgba(16, 185, 129, .25);
}
.search-form-button:hover{
  background: #059669;
}
.search-form-button:focus{
  outline: none;
  box-shadow: 0 0 0 1px #10b981, 0 0 0 4px rgba(16, 185, 129, .2);
}
.search-form-button:active{
  transform: translateY(1px);
}
</style>